// extracted by mini-css-extract-plugin
module.exports = {"col-btn-user-information":"ButtonUserInformation_col-btn-user-information__1Jdpn","session-info":"ButtonUserInformation_session-info__1UypO"};